import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import CreateButton from 'components/button/CreateButton';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import PropertygroupsList from './PropertygroupsList';
import translate from 'components/hoc/translate';

const PropertygroupsListContainer = (props) => {
    const {
        resource,
        translate,
    } = props;

    return (
        <div>
            <Header>
                <Title title={ translate('resources.propertygroups.plural') } />

                <Actions>
                    <CreateButton basePath={ resource } />
                </Actions>
            </Header>

            <PropertygroupsList
                { ...props }

            />
        </div>
    );
};

PropertygroupsListContainer.propTypes = {
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(PropertygroupsListContainer);



// WEBPACK FOOTER //
// ./src/pages/propertygroups/list/PropertygroupsListContainer.js